import axios from "axios";
import Api from "../../config/api/axios.urlcontext.js"

export default class ArmonizacionCSHacienda {

  async getSecretariaHacienda(url) {
    try {
        // console.log('getSecretariaHacienda');
        const res = await axios.get(Api.APP_URL_API+url);
        return res;
    } catch (error) {
        console.error(error.message);
    }
  }

  async getSecretariaHaciendaDisciplinaFinanciera(url) {
    try {
        // console.log('getSecretariaHaciendaDisciplinaFinanciera');
        const res = await axios.get(Api.APP_URL_API+url);
        return res;
    } catch (error) {
        console.error(error.message);
    }
  }

  async getSecretariaHaciendaAnexo(url) {
    try {
        // console.log('getSecretariaHaciendaDisciplinaFinanciera');
        const res = await axios.get(Api.APP_URL_API+url);
        return res;
    } catch (error) {
        console.error(error.message);
    }
  }

/**********************************************************************
/************ SECCION DE INVENTARIO DE BIENES *************************
**********************************************************************/

  async getIBPatrimonio(url) {
    try {
        // console.log('getSecretariaHaciendaDisciplinaFinanciera');
        const res = await axios.get(Api.APP_URL_API+url);
        return res;
      } catch (error) {
          console.error(error.message);
      }
    }

async getMobiliarioEquipo(url) {
  try {
      // console.log('getSecretariaHaciendaDisciplinaFinanciera');
      const res = await axios.get(Api.APP_URL_API+url);
      return res;
    } catch (error) {
        console.error(error.message);
    }
  }

  async getInventarioVehicular(url) {
    try {
        // console.log('getSecretariaHaciendaDisciplinaFinanciera');
        const res = await axios.get(Api.APP_URL_API+url);
        return res;
      } catch (error) {
          console.error(error.message);
      }
    }


/********************************************************************
 * *********** SECCION CUENTA PUBLICA FINANCIERA ********************
 * ******************************************************************/

  async getCuentaPublicaFinanciera(url){
    try {
      // console.log('getSecretariaHaciendaDisciplinaFinanciera');
        const res = await axios.get(Api.APP_URL_API+url);
        return res;
    } catch (error) {
      console.log(error);

    }
  }

  /********************************************************************
 * *********** SECCION CUENTA PUBLICA PRESUPUESTAL ********************
 * ******************************************************************/

  async getCuentaPublicaPresupuestal(url){
    try {
        const res = await axios.get(Api.APP_URL_API+url);
        return res;
    } catch (error) {
      console.log(error);

    }
  }

  /********************************************************************
 * *********** SECCION INFORMACION CONTABLE ********************
 * ******************************************************************/

  async getInformacionContable(url){
    try {
        const res = await axios.get(Api.APP_URL_API+url);
        return res;
    } catch (error) {
      console.log(error);

    }
  }

/********************************************************************
* *********** SECCION INFORMACION PRESUPUESTAL ********************
* ******************************************************************/
async getInformacionPresupuestal(url){
  try {
      const res = await axios.get(Api.APP_URL_API+url);
      return res;
  } catch (error) {
    console.log(error);

  }
}

async getInfoProgramatica(url){
  try {
      const res = await axios.get(Api.APP_URL_API+url);
      return res;
  } catch (error) {
    console.log(error);

  }
}
/*
async postPrueba(payload){
      let form = new FormData();
    form.append("Login", "21111101");
    form.append("Clave", "SFE462");

    const options = {
      method: 'POST',
      url: 'https://www.haciendachiapas.gob.mx/organismos-publicos/COSTOS24/Pag_Costos1raOctubre24/lista.asp',
      body: form
    };

    console.log(options);

    axios.request(options).then(function (response) {
      console.log(response.data);
      return response;
    }).catch(function (error) {
      console.error(error);
    });
}*/



}
